import PropTypes from 'prop-types';
import React from 'react';

import { BadgeTypes } from '../../../../constants/Badge';
import Badge from '../../Badge/Badge';

import './RowItemShuffleBadge.scss';

const RowItemShuffleBadge = React.memo(
  ({ canShuffle, isShuffleDisabled, shuffleOnclickIfDisabled, shuffleOnclick }) => {
    if (!canShuffle) {
      return null;
    }

    const props = {
      badgeType: BadgeTypes.SHUFFLE,
      isIcon: true,
      isShuffleDisabled,
      onClickIfShuffleDisabled: shuffleOnclickIfDisabled,
      onClick: shuffleOnclick,
    };

    return (
      <div className='RowItemShuffleBadge'>
        <Badge {...props} />
      </div>
    );
  },
);

RowItemShuffleBadge.propTypes = {
  canShuffle: PropTypes.bool,
  isShuffleDisabled: PropTypes.bool,
  shuffleOnclickIfDisabled: PropTypes.func,
  shuffleOnclick: PropTypes.func,
};

export default RowItemShuffleBadge;
